(() => {
  angular
    .module('complianceFrameworkApp.vms')
    .controller('VendorRepresentativeController', VendorRepresentativeController);

  /* ngInject */
  function VendorRepresentativeController($state, $stateParams, $window, Flash, sessionService, vendorService) {
    const vm = this;

    vm.id = $stateParams.id;
    vm.saveRepresentative = saveRepresentative;
    vm.vendor = {};
    vm.vendorRepresentative = {};
    vm.vendorRepresentatives = [];

    activate();

    function activate() {
      getVendor();
      getVendorRepresentatives();
    }

    function getVendor() {
      vendorService(sessionService.getAuthToken()).get({ id: vm.id }, response => vm.vendor = response);
    }

    function getVendorRepresentatives() {
      vendorService(sessionService.getAuthToken()).representatives({ id: vm.id }, response => vm.representatives = response);
    }

    function saveRepresentative() {
      vendorService(sessionService.getAuthToken()).create_representative({ id: vm.id, vendor_rep_id: vm.vendor_rep_id }, vm.vendorRepresentative, _ => {
        $state.go('application.vms.vendor-detail', { id: vm.id });
        Flash.create('success', 'Vendor assignment successfully created.');
      }, _ => {
        Flash.create('danger', 'An unexpected error occurred. Please try again.');
      });
    }
  }
})();
